import React from 'react'

// Иконки для компонента анализа товара
export const PlayIcon = () => (
    <svg width='28' height='28' viewBox='0 0 28 28' fill='none'>
        <path d='M9.33337 7.00002L19.8334 14L9.33337 21V7.00002Z' fill='currentColor' />
    </svg>
)

export const GalleryIcon = () => (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none'>
        <path
            d='M14 2H2C1.45 2 1 2.45 1 3V13C1 13.55 1.45 14 2 14H14C14.55 14 15 13.55 15 13V3C15 2.45 14.55 2 14 2ZM13 12H3V4H13V12Z'
            fill='currentColor'
        />
        <path d='M6 8L8 10L11 7L13 9V12H3V8L6 8Z' fill='currentColor' />
    </svg>
)

export const VideoIcon = () => (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none'>
        <path
            d='M14 2H2C1.45 2 1 2.45 1 3V13C1 13.55 1.45 14 2 14H14C14.55 14 15 13.55 15 13V3C15 2.45 14.55 2 14 2ZM13 12H3V4H13V12Z'
            fill='currentColor'
        />
        <path d='M6 8L8 10L11 7L13 9V12H3V8L6 8Z' fill='currentColor' />
    </svg>
)

export const BoxIcon = () => (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none'>
        <path
            d='M14 2H2C1.45 2 1 2.45 1 3V13C1 13.55 1.45 14 2 14H14C14.55 14 15 13.55 15 13V3C15 2.45 14.55 2 14 2ZM13 12H3V4H13V12Z'
            fill='currentColor'
        />
    </svg>
)

export const CloseIcon = () => (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none'>
        <path d='M12 4L4 12M4 4L12 12' stroke='currentColor' strokeWidth='2' strokeLinecap='round' />
    </svg>
)

/** Крестик очистки (как в поле поиска), заливка от текста/currentColor */
export const SearchClearIcon = () => (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M4.30711 12.6673C4.05926 12.6673 3.81142 12.576 3.61575 12.3804C3.23746 12.0023 3.23746 11.3764 3.61575 10.9982L10.9989 3.6176C11.3772 3.23944 12.0034 3.23944 12.3816 3.6176C12.7599 3.99576 12.7599 4.62168 12.3816 4.99984L4.99846 12.3804C4.81584 12.576 4.55495 12.6673 4.30711 12.6673Z'
            fill='currentColor'
        />
        <path
            d='M11.6903 12.6673C11.4424 12.6673 11.1946 12.576 10.9989 12.3804L3.61575 4.99984C3.23746 4.62168 3.23746 3.99576 3.61575 3.6176C3.99404 3.23944 4.62017 3.23944 4.99846 3.6176L12.3816 10.9982C12.7599 11.3764 12.7599 12.0023 12.3816 12.3804C12.186 12.576 11.9381 12.6673 11.6903 12.6673Z'
            fill='currentColor'
        />
    </svg>
)

export const RefreshIcon = () => (
    <svg width='14' height='14' viewBox='0 0 14 14' fill='none'>
        <path
            d='M1 7C1 10.866 4.134 14 8 14C11.866 14 15 10.866 15 7C15 3.134 11.866 0 8 0'
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
        />
        <path d='M5 3L1 7L5 11' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
)

export const ImportIcon = () => (
    <svg width='14' height='14' viewBox='0 0 14 14' fill='none'>
        <path
            d='M7 1V9M7 9L4 6M7 9L10 6'
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path d='M1 13H13' stroke='currentColor' strokeWidth='2' strokeLinecap='round' />
    </svg>
)

export const PlayCircleIcon = () => (
    <svg width='52' height='52' viewBox='0 0 52 52' fill='none'>
        <circle cx='26' cy='26' r='26' fill='rgba(255,255,255,0.1)' />
        <path d='M19 16L33 26L19 36V16Z' fill='currentColor' />
    </svg>
)

export const ArrowRightIcon = () => (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M9 18L15 12L9 6' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
)

// Компоненты иконок для анализа
interface CameraWithPhotoProps {
    className?: string
    background?: boolean
}

export const CameraWithPhoto: React.FC<CameraWithPhotoProps> = ({ className, background = true }) => {
    return (
        <div className={`relative ${className}`}>
            {background && (
                <div className='absolute bg-transparent left-1/2 size-[136px] top-1/2 -translate-x-1/2 -translate-y-1/2' />
            )}
            <div className='absolute h-[112px] left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[168px]'>
                <div className='absolute inset-0 bg-gray-600 rounded-lg opacity-40' />
            </div>
        </div>
    )
}

interface EditDocumentWithPencilProps {
    className?: string
    background?: boolean
}

export const EditDocumentWithPencil: React.FC<EditDocumentWithPencilProps> = ({ className, background = true }) => {
    return (
        <div className={`relative ${className}`}>
            {background && (
                <div className='absolute bg-transparent left-1/2 size-[136px] top-1/2 -translate-x-1/2 -translate-y-1/2' />
            )}
            <div className='absolute h-[112px] left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[168px]'>
                <div className='absolute inset-0 bg-gray-600 rounded-lg opacity-40' />
            </div>
        </div>
    )
}

interface ChartWithBarProps {
    className?: string
}

export const ChartWithBar: React.FC<ChartWithBarProps> = ({ className }) => {
    return (
        <div className={`relative ${className}`}>
            <div className='absolute bg-transparent left-1/2 size-[306px] top-1/2 -translate-x-1/2 -translate-y-1/2' />
            <div className='absolute h-[252px] left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[378px]'>
                <div className='absolute inset-0 bg-gradient-to-r from-purple-600 to-purple-700 rounded-3xl' />
            </div>
        </div>
    )
}
